import { render, staticRenderFns } from "./DesktopVoterReg.vue?vue&type=template&id=62196c90"
import script from "./DesktopVoterReg.vue?vue&type=script&lang=js"
export * from "./DesktopVoterReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports